import $ from 'jquery';

import {
  bindClearButton,
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  form: $(`#search-form`),
  dropdowns: $(`#search-form select`),
  clearButton: $(`#clear-button`),
};

const shipsByDateElements = {
  form: $(`#sbd-form`),
  submit: $(`#sbd-button`),
  dateInputs: $(`#ships_by_date`),
  checkBoxes: $(`.warehouse_product, #selectAll`),
};

export default class ShipsByDateService {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.shipsByDateFormElements = shipsByDateElements;
    this.bindElements();
  }

  static init() {
    if ($(`.ships-by-date.index`).length === 0) {
      return undefined;
    }

    return new ShipsByDateService();
  }

  bindElements() {
    bindClearButton(this.searchFormElements);
    bindSearchDropdowns(this.searchFormElements);
    this.bindCheckBoxes();
  }

  bindCheckBoxes() {
    this.shipsByDateFormElements.checkBoxes.click(() => {
      const checked = this.shipsByDateFormElements.checkBoxes.not(`#selectAll`).filter(`:checked`).length;
      const message = checked === 0 ? `Update SBD` : `Update SBD (${checked} selected)`;
      this.shipsByDateFormElements.submit.attr(`value`, message);
    });
  }
}
